import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { SubPayout } from 'anchor-shared/lib/model/entity/subPayout';

@Injectable()
export class SubPayoutDAO extends BaseDAO<SubPayout> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.SUBPAYOUT);
  }

  public updateFromPartial(
    payoutId: number,
    partialSubPayout: Partial<SubPayout>,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/partial/' +
      payoutId;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<SubPayout[]>(
      url,
      method,
      null,
      partialSubPayout,
      headers,
    );
  }

  public createMultiple(subPayouts: SubPayout[]): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/create-sub-payouts';
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      subPayouts,
      headers,
      null,
    );
  }

  public deleteMultiple(subPayouts: SubPayout[]): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/delete-sub-payouts';
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      subPayouts,
      headers,
      null,
    );
  }

  /**
   * Gets all the unpaid children of a parent payout
   * @param  {[number]} parentId [The parent Id of the child being marked as paid]
   * @param {[number]} childId [The id of the child being marked as paid, used to exclude from the response]
   */
  public getAllUnpaidChildrenForParent(parentId: number, childId: number) {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/unpaid-children/' +
      parentId +
      '/' +
      childId;
    let method = 'GET';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers, null);
  }

  public updateMultiple(subPayouts: Partial<SubPayout>[]): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/update-sub-payouts';
    let method = 'PUT';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(
      url,
      method,
      null,
      subPayouts,
      headers,
      null,
    );
  }
}
